export default "__VITE_ASSET__DWjt28YX__"